import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowLeft, KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const nav = useNavigate();
    const token = params.get("token") || "";
    const [pwd, setPwd] = useState("");
    const [pwd2, setPwd2] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    useEffect(() => {
        if (!token) toast.error("Link inválido — sem token");
    }, [token]);

    const submit = async (e) => {
        e.preventDefault();
        if (pwd.length < 6) {
            toast.error("Senha mínima 6 caracteres");
            return;
        }
        if (pwd !== pwd2) {
            toast.error("As duas senhas não coincidem");
            return;
        }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pwd });
            setDone(true);
            toast.success("Senha actualizada");
            setTimeout(() => nav("/conta/login"), 2500);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Erro a redefinir senha");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-paper flex items-center justify-center p-6 grid-bg" data-testid="reset-password-page">
            <div className="w-full max-w-md">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 mb-4 text-sm font-mono text-ink/60 hover:text-magenta"
                >
                    <ArrowLeft size={14} /> Voltar à loja
                </Link>
                <div className="border-2 border-ink bg-white p-8 shadow-[8px_8px_0_0_#0A0A0A]">
                    {done ? (
                        <div className="text-center" data-testid="reset-success">
                            <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-magenta bg-magenta/10 mb-4">
                                <CheckCircle2 size={26} className="text-magenta" />
                            </div>
                            <h1 className="font-display font-black text-2xl mb-3">Senha actualizada</h1>
                            <p className="text-sm text-ink/70 mb-6">
                                Pode agora iniciar sessão com a nova senha. A redirecionar…
                            </p>
                            <Link to="/conta/login" className="btn-primary w-full">
                                Ir para login
                            </Link>
                        </div>
                    ) : (
                        <>
                            <div className="text-center mb-7">
                                <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-ink bg-paper mb-3">
                                    <KeyRound size={22} />
                                </div>
                                <h1 className="font-display font-black text-2xl">Definir nova senha</h1>
                                <p className="text-sm text-ink/60 mt-2 font-mono">
                                    Mínimo 6 caracteres
                                </p>
                            </div>
                            <form onSubmit={submit}>
                                <label className="block mb-4">
                                    <span className="label-mono mb-2 block">Nova senha</span>
                                    <input
                                        type="password"
                                        value={pwd}
                                        onChange={(e) => setPwd(e.target.value)}
                                        className="input-edge"
                                        required
                                        minLength={6}
                                        autoFocus
                                        data-testid="new-password-input"
                                    />
                                </label>
                                <label className="block mb-6">
                                    <span className="label-mono mb-2 block">Confirmar nova senha</span>
                                    <input
                                        type="password"
                                        value={pwd2}
                                        onChange={(e) => setPwd2(e.target.value)}
                                        className="input-edge"
                                        required
                                        minLength={6}
                                        data-testid="new-password-confirm-input"
                                    />
                                </label>
                                <button
                                    type="submit"
                                    disabled={busy || !token}
                                    className="btn-primary w-full disabled:opacity-50"
                                    data-testid="reset-submit-btn"
                                >
                                    {busy && <Loader2 className="animate-spin" size={16} />}
                                    {busy ? "A actualizar…" : "Definir nova senha"}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
